<div class="label justify-end flex-row g-space-sm">
  <div>
    {{ 'communication.message.system.cases.to-do-closed.title' | translate: { title: this.case().Description ?? '' } }}
  </div>
  @if (this.case().AssigneeId) {
    <div>
      {{
        'communication.message.system.cases.to-do-closed.assignee'
          | translate
            : {
                name: this.getConversationParticipant(this.case().AssigneeId),
              }
      }}
    </div>
  }
</div>
